'use strict';exports.__esModule = true;exports.projectStatusesTitle = exports.bathToiletsTitle = exports.propertyTypesTitle = exports.roomsTitle = undefined;var _stringifySelect = require('./stringifySelect');var _stringifySelect2 = _interopRequireDefault(_stringifySelect);
var _constants = require('../constants');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var roomsTitle = exports.roomsTitle = function roomsTitle(values, translate, isfullTitle) {
  if (!values || values[0] === 'all' || !values.length) {
    return isfullTitle ? '' + translate('searchContainer', 'all_rooms') : '' + translate('searchContainer', 'all');
  }
  values.map(function (el) {return Number.isNaN(el) ? el : +el;});
  var rooms = (0, _stringifySelect2.default)(values.sort());

  if (isfullTitle) {
    if (+rooms === 1) {
      return translate('searchContainer', 'room');
    }
    return rooms + ' ' + translate('searchContainer', 'rooms');
  }
  return rooms + (values.length > 1 ? ' ' + translate('searchContainer', 'rooms') : '');
};

var propertyTypesTitle = exports.propertyTypesTitle = function propertyTypesTitle(values, translate, isfullTitle) {
  if (values.length < 2) {
    return values[0] && values[0] !== 'all' ? '' +
    translate('propertyTypes', values[0]) : '' +
    translate('search_box', 'searchContainer', isfullTitle ? 'all_property_types' : 'all');
  }
  return values.length + ' ' + translate('search_box', 'searchContainer', 'property_type');
};


var bathToiletsTitle = exports.bathToiletsTitle = function bathToiletsTitle(values, translate) {
  if (!values || values[0] === 'all' || !values.length) {
    return '' + translate('search_box', 'searchContainer', 'all');
  }
  values.map(function (el) {return Number.isNaN(el) ? el : +el;});
  var bathrooms = (0, _stringifySelect2.default)(values.sort());
  return bathrooms;
};

var projectStatusesTitle = exports.projectStatusesTitle = function projectStatusesTitle(values, locale, translate, isFullTitle) {
  if (values.length < 2) {
    return values[0] && values[0] !== 'all' ?
    _constants.projectStatuses.find(function (_ref) {var name = _ref.name;return values[0] === name;}).localisation[locale] : '' +
    translate('searchContainer', isFullTitle ? 'all_statuses' : 'all');
  }
  return values.length + ' ' + translate('searchContainer', 'status');
};


//////////////////
// WEBPACK FOOTER
// ./src/utils/multiselectsTitles.js
// module id = 200
// module chunks = 0